import { atom } from 'jotai';
export const accessTokenState = atom(undefined);
//# sourceMappingURL=access-token.js.map